import { render, staticRenderFns } from "./RequisitionPDFHeader.vue?vue&type=template&id=490c0cc4&scoped=true&"
import script from "./RequisitionPDFHeader.vue?vue&type=script&lang=js&"
export * from "./RequisitionPDFHeader.vue?vue&type=script&lang=js&"
import style0 from "./RequisitionPDFHeader.vue?vue&type=style&index=0&id=490c0cc4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c0cc4",
  null
  
)

export default component.exports